import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  parentGuardian: {
    description: 'Parent/guardian string used for displaying minor consentor name',
    defaultMessage: '{name} (parent/guardian)',
    id: 'jsOpkJ',
  },
  fluNasalSprayLabel: {
    description:
      'Describes which type of flu vaccine the patient is getting - in the form "Flu (nasal spray)"',
    defaultMessage: 'nasal spray',
    id: 'pbJho4',
  },
  fluStandardLabel: {
    description:
      'Describes which type of flu vaccine the patient is getting - in the form "Flu (standard)"',
    defaultMessage: 'standard',
    id: '+xlESR',
  },
  lotNumber: {
    description: 'The lot number of vaccine',
    defaultMessage: 'Lot number',
    id: 'YauMuN',
  },
  brandName: {
    description: 'Brand name of vaccine',
    defaultMessage: 'Brand name',
    id: 'rs94rX',
  },
  vaccinatingClinician: {
    description: 'Name of the vaccinating clinician',
    defaultMessage: 'Vaccinating clinician',
    id: 'tQKINW',
  },
  date: {
    description: 'The date of vaccination',
    defaultMessage: 'Vaccination date',
    id: 'nUDYHR',
  },
  location: {
    description: 'The name and location of the place where the patient received the vaccine',
    defaultMessage: 'Vaccination location',
    id: 'j+TtUE',
  },
  birthdate: {
    description: 'The birthdate of the patient',
    defaultMessage: 'Birthdate',
    id: 'ddMQHk',
  },
  firstDose: {
    description: 'Covid vaccination history page first dose',
    defaultMessage: 'First dose',
    id: 'VbEYqz',
  },
  secondDose: {
    description: 'Covid vaccination history page second dose',
    defaultMessage: 'Second dose',
    id: 'zbfXuJ',
  },
  thirdDose: {
    description: 'Covid vaccination history page third dose',
    defaultMessage: 'Third dose',
    id: 'jCibAj',
  },
  additionalDose: {
    description: 'An additional dose in vaccination series',
    defaultMessage: 'Additional dose',
    id: 'rLOjl7',
  },
  boosterDose: {
    description: 'A monovalent booster dose in COVID-19 vaccination series',
    defaultMessage: 'Monovalent booster',
    id: 'OsYMGs',
  },
  bivalentBoosterDose: {
    description: 'A bivalent booster dose in COVID-19 vaccination series',
    defaultMessage: 'Updated/Bivalent booster',
    id: 'To/13f',
  },
  viewDoseRecord: {
    description: 'Button for viewing other dose records in vaccination series',
    defaultMessage: 'View dose record',
    id: '8sXeh8',
  },
  viewVaccinationHistory: {
    description: 'Title text for vaccination history welcome page',
    defaultMessage: 'View your vaccination history.',
    id: 'UhAQpA',
  },
  consentText: {
    description: 'Consent text for confirm identity form',
    defaultMessage:
      'I agree to the Color <link1>Terms of Service</link1> and to Color’s <link2>Notice of Privacy Practices</link2>.',
    id: '2hbzX7',
  },
});
